import { render } from "./sysytemSubMenu.vue?vue&type=template&id=3e29bfd0&scoped=true"
import script from "./sysytemSubMenu.vue?vue&type=script&lang=js"
export * from "./sysytemSubMenu.vue?vue&type=script&lang=js"

import "./sysytemSubMenu.vue?vue&type=style&index=0&id=3e29bfd0&lang=less&scoped=true"

import exportComponent from "D:\\workspace\\zh-frontend\\microfront-main\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e29bfd0"]])

export default __exports__